/* Generado por el instalador. No editar a mano. */
import { lazy } from 'react';
export const SOLAR_INSTALLED = true;

export const SolarEnergy = lazy(() => import('../pages/SolarEnergy'));
export { startSolarFlowMetricsRelay } from '../services/solarFlowMetricsRelay';
export function preload_SolarEnergy() { return import('../pages/SolarEnergy'); }
export { getLastSolarBatteryPowerW } from '../services/solarFlowLiveTelemetry';
export { getLastSolarPvTotalPowerW } from '../services/solarFlowLiveTelemetry';
export { SOLAR_BATTERY_POWER_EVENT } from '../services/solarFlowLiveTelemetry';
export { SOLAR_PV_TOTAL_POWER_EVENT } from '../services/solarFlowLiveTelemetry';
export { solarDataCache } from '../services/solarDataCache';
export { default as SolarDiscoveryTab } from '../components/solar/SolarDiscoveryTab';
